import { __assign } from "tslib";
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Metadata } from './Metadata';
export var MetadataList = function (_a) {
    var items = _a.items, testId = _a.testId;
    return (jsx("div", { css: {
            display: 'flex',
            alignItems: 'center',
            '&:last-child': {
                marginRight: '0px',
            },
        }, "data-testid": testId }, items.map(function (item) { return (jsx(Metadata, __assign({ key: item.text }, item))); })));
};
//# sourceMappingURL=MetadataList.js.map